module.exports = __webpack_public_path__ + "img/XunJianGo_Logo.e6e57e3d.png";